(() => {
  let initialLoaderTimeout = setTimeout(() => {
    document.querySelectorAll('.product-treatment-options-loader').forEach(loader => loader.classList.remove('hidden'));
  }, 250);

  const refresh = (treatmentCountry) => {
    app.clinics.getClinics({
      withPrices: true
    }).then(clinics => {
      clearTimeout(initialLoaderTimeout);

      const homeClinicId = document.querySelector('[name="product_treatment_clinic_id"]')
        ? document.querySelector('[name="product_treatment_clinic_id"]').value
        : null;
      let startingPrice = false;
      let startingPriceFormatted = '';
      const countries = [];
      let treatments = 0;

      clinics = clinics.filter(clinic => clinic.isPresentation());

      clinics.forEach(clinic => {
          const isHomeClinic = homeClinicId == clinic.getShopifyId();

          if (countries.indexOf(clinic.getCountryIsoCode()) === -1) {
            countries.push(clinic.getCountryIsoCode());
          }

          if (clinic.getCountryIsoCode() === treatmentCountry) {
            clinic.getTreatments().forEach(treatment => {
              if (treatment.getLocalPrice() > 0
                && (startingPrice > treatment.getPrice() || startingPrice === false)
                && (
                  (isHomeClinic && treatment.isForOwnDonor())
                  || (!isHomeClinic && !treatment.isForOwnDonor())
                )
              ) {
                startingPrice = treatment.getLocalPrice();
                startingPriceFormatted = treatment.getLocalPriceFormatted();
              }

              treatments++;
            });
          }
        });

      document.querySelectorAll('[data-treatment-options-clinics]').forEach(div => div.innerHTML = clinics.length);
      document.querySelectorAll('[data-treatment-options-countries]').forEach(div => div.innerHTML = countries.length);
      document.querySelectorAll('[data-treatment-options-price]').forEach(div => div.innerHTML = startingPriceFormatted);
      document.querySelectorAll('.product-treatment-options-loader').forEach(loader => loader.classList.add('hidden'));
    });
  };

  onBroadcast('treatment_country', data => {
    //refresh(data.code.toLowerCase());
  });

  onBroadcast('treatments_selected', data => {
    const box = document.querySelector('.product-treatment-options-box');

    if (!box) {
      return;
    }

    box.querySelector('.product-treatment-options-added-clinic').innerText = data.clinic.getName();

    const treatmentsDiv = box.querySelector('.product-treatment-options-added-treatments');
    treatmentsDiv.innerHTML = '';

    data.treatments.forEach(treatment => {
      const treatmentDiv = document.createElement('div');
      treatmentDiv.classList.add('product-treatment-options-added-treatment');
      treatmentDiv.dataset.variantId = treatment.getShopifyId();
      treatmentDiv.innerHTML = `
        <div class="product-treatment-options-added-treatment-name">${treatment.getVariantName()}</div>
        <div class="product-treatment-options-added-treatment-price">${treatment.getLocalPriceFormatted()}</div>
      `;
      treatmentsDiv.appendChild(treatmentDiv);
    });

    box.classList.add('added');
  });

  if (app.treatmentCountry.currentCountry) {
    //refresh(app.treatmentCountry.currentCountry);
  }

  const modal = document.querySelector('#popup-treatments');
  const add = document.querySelector('.product-treatment-options-add');
  const edit = document.querySelector('.product-treatment-options-header-edit a');

  if (add) {
    add.addEventListener('click', e => {
      e.preventDefault();

      if (modal) {
        modal.open();
      }
    });
  }

  if (edit) {
    edit.addEventListener('click', e => {
      e.preventDefault();

      if (modal) {
        modal.form.goToStep(1);
        modal.open();
      }
    });
  }

  if (modal) {
    document.body.appendChild(modal);
  }
})();